import React, { Component } from 'react';
import * as THREE from 'three';
import TWEEN from '@tweenjs/tween.js';
import { TweenLite } from 'gsap';
import './Screensaver.css';

/*
HELPERS
~~~~~~~~~~~~~~~~~~~*/

function getRandomPositions() {
  let positions = [];
  for (let i = 0; i < 100; i++) {
    positions.push(getRandomInt(-50, 50))
  }
  return positions;
}

function getRandomZPositions() {
  let positions = [];
  for (let i = 0; i < 100; i++) {
    if (Math.random() >= 0.5) {
      positions.push(getRandomInt(-200, -150))
    }
    else {
      positions.push(getRandomInt(80, 110))
    }
  }
  return positions;
}

function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

var height = 5,
    size = 10,
    curveSegments = 2,
    bevelEnabled = false,
		bevelThickness = 20,
		bevelSize = 1,
		bevelSegments = 3,
    font = undefined;

export default class Screensaver extends Component {
  componentWillUnmount() {
    const {
      intervalId
    } = this.state;
    clearInterval(intervalId);
  }

  componentDidMount() {
    const {
      text,
      sizeMultiplier,
      speedMultiplier
    } = this.props;

    var scene = new THREE.Scene()
    var camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 1, 1000)
    var renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setPixelRatio( window.devicePixelRatio );;
    renderer.setClearColor( 0x000000, 1 );
    renderer.setSize(window.innerWidth, window.innerHeight)
    renderer.shadowMap.enabled = true
    renderer.shadowMapSoft = true

    camera.position.x = 0
    camera.position.y = 0
    camera.position.z = 200;

    //GEOMETRY
    var cubeMat = new THREE.MeshPhongMaterial( {
			color: 0x156289,
			emissive: 0x072534,
			side: THREE.DoubleSide,
			shading: THREE.FlatShading
		});

    var lights = [];
		lights[ 0 ] = new THREE.PointLight( 0xaaaaaa, 1, 0 );
		lights[ 1 ] = new THREE.PointLight( 0xaaaaaa, 1, 0 );
		lights[ 2 ] = new THREE.PointLight( 0xaaaaaa, 1, 0 );

		lights[ 0 ].position.set( 0, 200, 0 );
		lights[ 1 ].position.set( 100, 200, 100 );
		lights[ 2 ].position.set( - 100, - 200, - 100 );

		scene.add( lights[ 0 ] );
		scene.add( lights[ 1 ] );
		scene.add( lights[ 2 ] );
    camera.lookAt(scene.position)

    document.getElementById('screensaver-canvas-container')
      .appendChild( renderer.domElement );

    function loadFont() {
      var loader = new THREE.FontLoader();
      loader.load('/resources/Tahoma_Regular.json', function (res) {
        font = res;
        createText(text);
      });
    }

    let textMesh;

    function createText(textStr) {
      let textGeo = new THREE.TextGeometry(textStr, {
        font: font,
        size: size * sizeMultiplier,
        height: height * sizeMultiplier,
        curveSegments: curveSegments,
        weight: "bold",
        bevelThickness: bevelThickness,
        bevelSize: bevelSize,
        bevelSegments: bevelSegments,
        bevelEnabled: bevelEnabled
      });
      textGeo.computeBoundingBox();
      textGeo.computeVertexNormals();
      textGeo.center();
      textMesh = new THREE.Mesh(textGeo, cubeMat)
      textMesh.castShadow = false;
      scene.add(textMesh)

      new TWEEN.Tween(textMesh.position)
        .to({
          x: getRandomPositions(),
          y: getRandomPositions(),
          z: getRandomZPositions(),
        }, 200000)
        .repeat(Infinity)
        .start();
    }

    let speed = 0.3 * speedMultiplier;
    let yRotationSpeed = speed * 0.3;
    let zRotationSpeed = speed * 0.1;
    let xRotationSpeed = speed * 0.1;

    let rotateRight = true;
    let rotateZ = true;
    let rotateX = true;

    var render = function () {
      requestAnimationFrame( render );
      TWEEN.update();
      if (textMesh) {
        if (textMesh.rotation.y >= 1.5) {
          rotateRight = false;
        }
        else if (textMesh.rotation.y <= -1.5) {
          rotateRight = true;
        }

        if (textMesh.rotation.z >= 0.8) {
          rotateZ = false;
        }
        else if (textMesh.rotation.z <= -0.8) {
          rotateZ = true;
        }

        if (textMesh.rotation.x >= 1.2) {
          rotateX = false;
        }
        else if (textMesh.rotation.x <= -1.2) {
          rotateX = true;
        }

        if (rotateRight) {
          // textMesh.rotation.x += 0;
          textMesh.rotation.y += yRotationSpeed;
          // textMesh.rotation.z += z;
        }
        else {
          textMesh.rotation.y -= yRotationSpeed;
        }

        if (rotateZ) {
          textMesh.rotation.z += zRotationSpeed;
        }
        else {
          textMesh.rotation.z -= zRotationSpeed;
        }

        if (rotateX) {
          textMesh.rotation.x += xRotationSpeed;
        }
        else {
          textMesh.rotation.x -= xRotationSpeed;
        }
      }
      renderer.render(scene, camera);
    };
    loadFont();
    render();

    var colors = [
      new THREE.MeshBasicMaterial({
        color: 0xF68A90
      }),
      new THREE.MeshBasicMaterial({
        color: 0xffffff
      }),
      new THREE.MeshBasicMaterial({
        color: 0xEDE6D4
      }),
      new THREE.MeshBasicMaterial({
        color: 0xFFFF7F
      }),
      new THREE.MeshBasicMaterial({
        color: 0x6CCE74
      }),
      new THREE.MeshBasicMaterial({
        color: 0x0FEF7C
      }),
      new THREE.MeshBasicMaterial({
        color: 0x84FFFF
      }),
      new THREE.MeshBasicMaterial({
        color: 0x0589F5
      }),
      new THREE.MeshBasicMaterial({
        color: 0xEB77BF
      }),
      new THREE.MeshBasicMaterial({
        color: 0xFF84FF
      }),
      new THREE.MeshBasicMaterial({
        color: 0xFF0D05
      }),
      new THREE.MeshBasicMaterial({
        color: 0xFFFF00
      }),
      new THREE.MeshBasicMaterial({
        color: 0x7DF80A
      }),
      new THREE.MeshBasicMaterial({
        color: 0xFA7705
      }),
      new THREE.MeshBasicMaterial({
        color: 0x00FFFF
      }),
      new THREE.MeshBasicMaterial({
        color: 0x2992B3
      }),
      new THREE.MeshBasicMaterial({
        color: 0xFF00FB
      }),
    ];

    let intervalId = setInterval(function changeColor () {
      var target = cubeMat;
      var initial = new THREE.Color(target.color.getHex());
      let randomColor = colors[Math.floor(Math.random() * colors.length)];
      var value = new THREE.Color(randomColor.color.getHex());
      TweenLite.to(initial, 1, {
          r: value.r,
          g: value.g,
          b: value.b,
          ease: TWEEN.Easing.Cubic.InOut,
          onUpdate: function() { target.color = initial; }
      });
    }, 3000);
    this.setState({
      intervalId: intervalId
    });
  }

  render () {
    const {
      hideScreensaver
    } = this.props;

    return (
      <div id="screensaver-canvas-container" onClick={hideScreensaver}/>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/screensaver/Screensaver.jsx